export interface PriceTraceWarehouse {
  id?: number | null;
  vendor_id?: string | null;
  name?: string | null;
}

export interface PriceTracePromotion {
  id?: number | null;
  vendor_id?: string | null;
  title?: string | null;
  type?: string | null;
  priority?: number | null;
  description?: string | null;
  valid_from?: string | null;
  valid_to?: string | null;
}

export interface PriceTraceStep {
  key?: string | null;
  modifier?: string | null;
  title?: string | null;
  description?: string | null;
  before?: number | null;
  after?: number | null;
  delta?: number | null;
  applied?: boolean | null;
  priority?: number | null;
  source?: string | null;
  ref_type?: 'promotion' | 'discount_document' | string | null;
  ref_id?: number | string | null;
}

export interface PriceTraceItem {
  warehouse?: PriceTraceWarehouse | null;
  client_base_price?: number | null;
  offer_price?: number | null;
  available_price?: number | null;
  promotion?: PriceTracePromotion | null;
  discount_value?: number | null;
  price_type?: string | null;
  regional_base_price?: number | null;
  in_differential_cache?: boolean | null;
  steps?: PriceTraceStep[] | null;
}

export interface PriceTraceData {
  outletVendorId?: string | null;
  productCode?: number | null;
  productName?: string | null;
  date?: string | null;
  items?: PriceTraceItem[] | null;
}

export interface PriceTraceResponse {
  data?: PriceTraceData | null;
  errors?: string[];
}

export const priceTypeLabels: Record<string, string> = {
  base: 'Цена прайса',
  discount_document: 'Договорная скидка',
  promotion: 'Акция',
  promotion_on_document: 'Акция поверх договора',
  differential: 'Дифференциальная цена',
};
